module.exports = __webpack_public_path__ + "assets/img/abeb12ae35558165101104f579d1ade3.svg";